import { useEffect, useLayoutEffect } from 'react';
import LogRocket from 'logrocket';
import { useLocation } from 'react-router';
import { useAppAuth } from '../auth/AppAuthContext';
import {
  buildLogRocketIdentity,
  classifyLeadType,
  getActiveHermetiqAttribution,
  getStoredHermetiqAttribution,
  isHostedDashboardOrigin,
  isNewlyCreatedUser,
  readHermetiqAttribution,
  recordAcquisitionEvent,
  storeHermetiqAttribution,
} from '../utils/acquisition';
import { logRocketId } from '../utils/runtimeConfig';

export default function AcquisitionTracker() {
  const location = useLocation();
  const { user, isInitialized } = useAppAuth();

  useLayoutEffect(() => {
    const attribution = readHermetiqAttribution(location.search);
    if (attribution) storeHermetiqAttribution(attribution);
  }, [location.search]);

  useEffect(() => {
    if (location.pathname !== '/login') return;

    const attribution = getActiveHermetiqAttribution(location.search);
    if (!attribution) return;

    void recordAcquisitionEvent('Signup page viewed', attribution, {
      onceKey: `${attribution.campaign}:${attribution.placement}`,
    });
  }, [location.pathname, location.search]);

  useEffect(() => {
    if (!isInitialized || !user) return;

    const attribution = getStoredHermetiqAttribution();
    const identity = buildLogRocketIdentity(user, attribution);
    if (logRocketId && identity && isHostedDashboardOrigin(window.location.origin)) {
      LogRocket.identify(identity.uid, identity.traits);
    }

    if (!attribution) return;

    const event = isNewlyCreatedUser(user) ? 'Account created' : 'Account login completed';
    const userKey = String(user.user_id || user.id || '').trim();
    if (!userKey) return;

    void recordAcquisitionEvent(event, attribution, {
      leadType: classifyLeadType(user, attribution),
      onceKey: `${userKey}:${attribution.campaign}:${attribution.placement}`,
    });
  }, [isInitialized, user]);

  return null;
}
